/*
  Revelado por scroll de AYRO.

  Marca las secciones del contenido y las muestra cuando entran en pantalla.
  Deliberadamente chico: una sola pasada, sin dependencias y sin tocar el markup
  de ninguna seccion.

  Decisiones:

  - Trabaja a nivel seccion, no elemento por elemento. Animar cada titulo y cada
    parrafo por separado obliga a conocer el interior de cada seccion, se rompe
    cuando alguien edita una en el theme editor, y ademas se ve recargado.

  - El hero queda afuera: esta arriba del fold, y revelarlo por scroll significa
    que el visitante llega a una pantalla vacia que se llena sola.

  - El header group tambien: la barra de beneficios ya tiene su propia entrada y
    el header es sticky.

  - Se revela una sola vez. Volver a esconder al scrollear para arriba marea y
    no aporta nada.
*/
(function () {
  var CLASE = 'ayro-reveal';
  var VISIBLE = 'is-visible';
  var LISTO = 'ayro-reveal--listo';

  /* Sin IntersectionObserver no se esconde nada: mejor sin animacion que con
     contenido invisible. */
  if (!('IntersectionObserver' in window)) return;

  var raiz = document.documentElement;

  function candidatas() {
    var main = document.querySelector('main');
    if (!main) return [];

    var secciones = Array.prototype.slice.call(
      main.querySelectorAll('[id^="shopify-section-"]')
    );

    /* Solo las de primer nivel: una seccion anidada dentro de otra se revelaria
       dos veces y la de adentro quedaria escondida hasta que la de afuera
       termine. */
    secciones = secciones.filter(function (seccion) {
      return !secciones.some(function (otra) {
        return otra !== seccion && otra.contains(seccion);
      });
    });

    /* Fuera la primera: es el hero. */
    return secciones.slice(1);
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;

        var nodo = entrada.target;
        observador.unobserve(nodo);
        nodo.classList.add(VISIBLE);

        /* 560ms es lo que dura la transicion en el CSS. Pasado eso se suelta el
           will-change. */
        window.setTimeout(function () {
          nodo.classList.add(LISTO);
        }, 560);
      });
    },
    {
      /* Un margen negativo abajo: la seccion arranca cuando ya entro de verdad,
         no cuando asoma un pixel. Con 12% el movimiento acompaña al scroll en
         vez de adelantarsele. */
      rootMargin: '0px 0px -12% 0px',
      threshold: 0,
    }
  );

  function arrancar() {
    var nodos = candidatas();
    if (!nodos.length) return;

    nodos.forEach(function (nodo) {
      nodo.classList.add(CLASE);
    });

    /* La clase en <html> va recien ahora: hasta este punto nada esta escondido,
       asi que si algo de arriba fallo la web se ve normal. */
    raiz.classList.add('ayro-reveal-listo');

    nodos.forEach(function (nodo) {
      observador.observe(nodo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/*
  Titulo rotativo de la pestana.

  Va pasando los tres beneficios en el titulo del navegador.

  El HTML que sirve Shopify conserva el titulo real ("AYRO - Ventilador de cuello
  portatil | Envio gratis a todo el pais"): esto corre despues de cargar y pisa el
  <title> en el DOM, no en la respuesta del servidor. O sea que el crawler que lee
  el HTML crudo ve el titulo bueno. El que ademas ejecuta JavaScript puede llegar a
  ver el mensaje rotando, asi que si algun dia el titulo en Google aparece como una
  promo, la salida es rotar solo con la pestana en segundo plano y devolver el
  titulo original al volver.

  El intervalo lo frena el navegador a un minimo de un segundo cuando la pestana
  esta en segundo plano, que es justo cuando el titulo se lee: 2,5s queda igual.
*/
(function () {
  var MARCA = 'AYRO — ';
  var MENSAJES = [
    '10% OFF en transferencia',
    'Envío gratis a todo el país',
    '3 cuotas sin interés'
  ];
  var CADA = 2500;

  if (MENSAJES.length < 2) return;

  /* En el editor de temas el titulo lo maneja Shopify y cambiarlo confunde. */
  if (window.Shopify && window.Shopify.designMode) return;

  var i = 0;

  function girar() {
    document.title = MARCA + MENSAJES[i];
    i = (i + 1) % MENSAJES.length;
  }

  girar();
  window.setInterval(girar, CADA);
})();
